import apiClient from './apiClient';

// System Settings API
export const systemSettingsApi = {
  // Settings abrufen
  get: async () => {
    const response = await apiClient.get('/system-settings');
    return response.data;
  },

  // Settings aktualisieren
  update: async (data) => {
    const response = await apiClient.put('/system-settings', data);
    return response.data;
  },

  // Pflichtfelder abrufen
  getPflichtfelder: async () => {
    const response = await apiClient.get('/system-settings/pflichtfelder');
    return response.data;
  },

  // Pflichtfelder aktualisieren
  updatePflichtfelder: async (pflichtfelder) => {
    const response = await apiClient.put('/system-settings/pflichtfelder', { pflichtfelder });
    return response.data;
  },

  // Pflichtfelder auf Standard zurücksetzen
  resetPflichtfelder: async () => {
    const response = await apiClient.post('/system-settings/pflichtfelder/reset');
    return response.data;
  },

  // Öffnungszeiten abrufen
  getOeffnungszeiten: async () => {
    const response = await apiClient.get('/system-settings/oeffnungszeiten');
    return response.data;
  },

  // Öffnungszeiten aktualisieren (synchronisiert Kalender + KI-Agent)
  updateOeffnungszeiten: async (oeffnungszeiten) => {
    const response = await apiClient.put('/system-settings/oeffnungszeiten', { oeffnungszeiten });
    return response.data;
  },

  // Leistungen abrufen (angeboten + nicht angeboten)
  getLeistungen: async () => {
    const response = await apiClient.get('/system-settings/leistungen');
    return response.data;
  },

  // Leistungen aktualisieren
  updateLeistungen: async (angebotenLeistungen, nichtAngeboten) => {
    const response = await apiClient.put('/system-settings/leistungen', { angebotenLeistungen, nichtAngeboten });
    return response.data;
  },

  // Leistungen auf Standard zurücksetzen
  resetLeistungen: async () => {
    const response = await apiClient.post('/system-settings/leistungen/reset');
    return response.data;
  }
};

// KVA-Bestätigung API
export const kvaBestaetingApi = {
  // Alle pending abrufen
  getAll: async (status = 'PENDING') => {
    const response = await apiClient.get('/kva-bestaetigung', { params: { status } });
    return response.data;
  },

  // Einzelne abrufen
  getById: async (id) => {
    const response = await apiClient.get(`/kva-bestaetigung/${id}`);
    return response.data;
  },

  // Genehmigen
  approve: async (id) => {
    const response = await apiClient.post(`/kva-bestaetigung/${id}/approve`);
    return response.data;
  },

  // Ablehnen
  reject: async (id, grund) => {
    const response = await apiClient.post(`/kva-bestaetigung/${id}/reject`, { grund });
    return response.data;
  },

  // Löschen
  delete: async (id) => {
    const response = await apiClient.delete(`/kva-bestaetigung/${id}`);
    return response.data;
  }
};

// Termin-Bestätigung API
export const terminBestaetingApi = {
  // Alle pending abrufen
  getAll: async (status = 'PENDING') => {
    const response = await apiClient.get('/termin-bestaetigung', { params: { status } });
    return response.data;
  },

  // Einzelne abrufen
  getById: async (id) => {
    const response = await apiClient.get(`/termin-bestaetigung/${id}`);
    return response.data;
  },

  // Genehmigen
  approve: async (id) => {
    const response = await apiClient.post(`/termin-bestaetigung/${id}/approve`);
    return response.data;
  },

  // Ablehnen
  reject: async (id, grund) => {
    const response = await apiClient.post(`/termin-bestaetigung/${id}/reject`, { grund });
    return response.data;
  },

  // Löschen
  delete: async (id) => {
    const response = await apiClient.delete(`/termin-bestaetigung/${id}`);
    return response.data;
  }
};

export default {
  systemSettingsApi,
  kvaBestaetingApi,
  terminBestaetingApi
};
